
import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import ChartSeries from 'app/react/chart/ChartSeries.jsx';
import LineChart  from 'app/react/chart/LineChart.jsx';
//import ReportTable from 'app/react/ReportTable.jsx';


 const bootstrapcss = require('bootstrap/dist/css/bootstrap.min.css');
 global.jQuery = global.$ = require('jquery');
 const bootstrapjs = require('bootstrap/dist/js/bootstrap.min.js');

 console.log('bootstrapcss', bootstrapcss)


//console.log('bootstrap is enabled: ', bootstrap_enabled)

// bielany - strona do zagniezdzenia
// http://www.bielany.waw.pl/page/210,monitoring-powietrza.html
// import react and some other libs
import {
  Moment, DOMTools
} from 'app/react/Boot.jsx';

require('react-d3');

import KrynicaCon from '../krynica/KrynicaCon.jsx';


class ExcentoCon extends KrynicaCon {

  constructor(props) {
    super(props);

    //this.headerRenderer = new HeaderRenderer();
    //this.cellRenderer = new CellRenderer();
    this.state = {
      lines: [],
      rows: [],
      charts: [],
      data: "",
      json: {},
      teaserValues: [],
      activeTab: null,
      activeView: ''
    };

    this.displayMode = this.configureDisplayModes();

    var codes = [

    ];

    this.viewConfig ={
      headersDescription: {
        headers: [
            {code: 'Data', colspan: 1 },
            {code: 'ul. Sobieskiego 7', colspan: 1},
            {code: 'ul. Sabata 12', colspan: 1},
            {code: 'ul. Różana', colspan: 1},
            {code: 'ul. Kujawska 8A', colspan: 1},
            {code: 'ul. Kościelna (Skwer Plac Kaszubski)', colspan: 1},
        ],
      },

      enabledViews: ["1h", "24h"],
      enabledTabs: ["default", "comparison", "meteo"],

      tabs: {
        "default": {
          name: "Lokalizacje pomiarowe",
          codes: [
            // {title: "Urząd Miejski Rumia ul. Sobieskiego 7", codes: ["04PM10A_6_k", "04PM25A_6", "04PM01A_6"]},
            // {title: "Rumia ul. Sabata 12", codes: ["05PM10A_6_k", "05PM25A_6", "05PM01A_6"]},
            // {title: "Rumia ul. Różana", codes: ["06PM10A_6_k", "06PM25A_6", "06PM01A_6"]},
            // {title: "Rumia ul. Kujawska 8A", codes: ["07PM10A_6_k", "07PM25A_6", "07PM01A_6"]},
            // {title: "Rumia ul. Kościelna (Skwer Plac Kaszubski)", codes: ["08PM10A_6_k", "08PM25A_6", "08PM01A_6"]},
                {title: "Urząd Miejski Rumia ul. Sobieskiego 7", codes: ["RU01.PM10_k"]},
                {title: "Rumia ul. Sabata 12", codes: ["RU02.PM10_k"]},
                {title: "Rumia ul. Różana", codes: ["RU03.PM10_k"]},
                {title: "Rumia ul. Kujawska 8A", codes: ["RU04.PM10_k"]},
                {title: "Rumia ul. Kościelna (Skwer Plac Kaszubski)", codes: ["RU05.PM10_k"]},
          ],
        },
        "comparison": {
          name: "Porównanie",
          codes: [
            {title: "Rumia porównanie PM10", codes: ["RU01.PM10_k", "RU02.PM10_k", "RU03.PM10_k", "RU04.PM10_k", "RU05.PM10_k" ]},
          ],
        },
        "meteo": {
          name: "Meteo",
          codes: [
            {title: "Wilgotność", codes: ["RU01.RH", "RU02.RH", "RU03.RH", "RU04.RH", "RU05.RH"]},
            {title: "Ciśnienie", codes: ["RU01.PA", "RU02.PA", "RU03.PA", "RU04.PA", "RU05.PA"]},
            {title: "Temperatura", codes: ["RU01.TA", "RU02.TA", "RU03.TA", "RU04.TA", "RU05.TA"]},
                      ],
        },
        "default_24h": {
          name: "Lokalizacje pomiarowe",
          codes: [
            // {title: "Urząd Miejski Rumia ul. Sobieskiego 7", codes: ["04PM10A_6_k", "04PM25A_6", "04PM01A_6"]},
            // {title: "Rumia ul. Sabata 12", codes: ["05PM10A_6_k", "05PM25A_6", "05PM01A_6"]},
            // {title: "Rumia ul. Różana", codes: ["06PM10A_6_k", "06PM25A_6", "06PM01A_6"]},
            // {title: "Rumia ul. Kujawska 8A", codes: ["07PM10A_6_k", "07PM25A_6", "07PM01A_6"]},
            // {title: "Rumia ul. Kościelna (Skwer Plac Kaszubski)", codes: ["08PM10A_6_k", "08PM25A_6", "08PM01A_6"]},
            { title: "Urząd Miejski Rumia ul. Sobieskiego 7", codes: ["RU01.PM10_k"] },
            { title: "Rumia ul. Sabata 12", codes: ["RU02.PM10_k"] },
            { title: "Rumia ul. Różana", codes: ["RU03.PM10_k"] },
            { title: "Rumia ul. Kujawska 8A", codes: ["RU04.PM10_k"] },
            { title: "Rumia ul. Kościelna (Skwer Plac Kaszubski)", codes: ["RU05.PM10_k"] },

          ],
        },
        "comparison_24h": {
          name: "Frakcje pyłu",
          codes: [
            {title: "Rumia porównanie PM10", codes: ["RU01.PM10_k", "RU02.PM10_k", "RU03.PM10_k", "RU04.PM10_k", "RU05.PM10_k" ]},
            // {title: "Rumia porównanie PM2.5", codes: ["04PM25A_6", "05PM25A_6", "06PM25A_6", "07PM25A_6", "08PM25A_6" ]},
            // {title: "Rumia porównanie PM1", codes: ["04PM01A_6", "05PM01A_6", "06PM01A_6", "07PM01A_6", "08PM01A_6" ]},
          ]
        },
        "meteo_24h": {
          name: "Meteo",
          codes: [
            {title: "Wilgotność", codes: ["RU01.RH", "RU02.RH", "RU03.RH", "RU04.RH", "RU05.RH"]},
            {title: "Ciśnienie", codes: ["RU01.PA", "RU02.PA", "RU03.PA", "RU04.PA", "RU05.PA"]},
            {title: "Temperatura", codes: ["RU01.TA", "RU02.TA", "RU03.TA", "RU04.TA", "RU05.TA"]},
          ],
        },
      },

      // list of all measurements
      // this is used for getting data
      codes: codes,

      views: [
        //        "teaser",
        //        "normal",
        "charts",
        //        "table"
      ],

      blocks: {

        // teaser config
        teaser : {
          codes: codes,
        },

        // normal config
        normal : {

        },

        // list of charts
        charts : {

          // list of measurement codes
          codes: codes,

        },
        // table of everything
        tablething : {
          codes: ["RU01.PM10_k", "RU02.PM10_k", "RU03.PM10_k", "RU04.PM10_k", "RU05.PM10_k" ],
          "meteo": {
            codes: ["RU01.RH", "RU01.PA", "RU01.TA", "RU02.RH", "RU02.PA", "RU02.TA", "RU03.RH", "RU03.PA", "RU03.TA", "RU04.RH", "RU04.PA", "RU04.TA", "RU05.RH", "RU05.PA", "RU05.TA"],
            headersDescription: {
              headers: [
                {code: 'Data', colspan: 1 },
                {code: 'ul. Sobieskiego 7', colspan: 3},
                {code: 'ul. Sabata 12', colspan: 3},
                {code: 'ul. Różana', colspan: 3},
                {code: 'ul. Kujawska 8A', colspan: 3},
                {code: 'ul. Kościelna (Skwer Plac Kaszubski)', colspan: 3},
              ],
            }
          }
        }

      }
    };

    for (var name in this.viewConfig.tabs) {
      this.viewConfig.tabs[name]._id = name;
    }

    this.state.activeTab = this.viewConfig.tabs.default;
    this.colors = [
      'orange', 'maroon', 'olive', 'magenta', 'purple', 'red', 'green', 'blue', 'purple', 'black',
      'red', 'green', 'blue', 'purple', 'orange', 'brown', 'pink', 'lightblue', 'lightgreen', 'magenta', 'purple', 'black',
      'red', 'green', 'blue', 'purple', 'orange', 'brown', 'pink', 'lightblue', 'lightgreen', 'magenta', 'purple', 'black',
      'red', 'green', 'blue', 'purple', 'orange', 'brown', 'pink', 'lightblue', 'lightgreen', 'magenta', 'purple', 'black',
      'red', 'green', 'blue', 'purple', 'orange', 'brown', 'pink', 'lightblue', 'lightgreen', 'magenta', 'purple', 'black',
    ];
  }

  getStationForChart(code) {
    var reg = /RU(\d+).*/;
    var match = code.match(reg);
    var num = (parseInt(match[1]));
    var name;

    switch (num) {
      case 1:
        name = "Sobieskiego";
      break;
      case 2:
        name = "Sabata";
      break;
      case 3:
        name = "Różana";
      break;
      case 4:
        name = "Kujawska";
      break;
      case 5:
        name = "Kościelna";
      break;
    }

    //return "Rumia " + (parseInt(match[1]) - 3);
    return name;
  }
}

export default ExcentoCon;



// WEBPACK FOOTER //
// ./app/react/excento/ExcentoCon.jsx